import { NgModule } from '@angular/core';
import { AclCategoryModule } from './acl-category/form/acl-category.module';
import { CheckBoxListControlModule } from './check-box-list/form/check-box-list-control.module';
import { ComplexControlModule } from './complex/form/complex-control.module';
import { ContactControlModule } from './contact/form/contact-control.module';
import { CostsControlModule } from './costs/form/costs-control.module';
import { DateTimeControlModule } from './datetime/form/date-time-control.module';
import { FeeControlModule } from './fee/form/fee-control.module';
import { ListPickerControlModule } from './list-picker/form/list-picker-control.module';
import { MembershipControlModule } from './membership/form/membership-control.module';
import { PassAlertFailControlModule } from './pass-alert-fail/form/pass-alert-fail-control.module';
import { RegLookupControlModule } from './reglookup/form/reg-lookup-control.module';
import { RichTextControlModule } from './rich-text/form/rich-text-control.module';
import { SelectContactControlModule } from './select-contact/form/select-contact-control.module';
import { SelectControlConfigModule } from './select/config/select-control-config.module';
import { SplatControlModule } from './splat/form/splat-control.module';
import { TextControlModule } from './text/form/text-control.module';
import { TextareaControlModule } from './textarea/form/textarea-control.module';
import { ToggleControlModule } from './toggle/form/toggle-control.module';
import { UserListPickerControlModule } from './user-list-picker/form/user-list-picker-control.module';

@NgModule({
    imports: [
        AclCategoryModule,
        CheckBoxListControlModule,
        ComplexControlModule,
        ContactControlModule,
        CostsControlModule,
        DateTimeControlModule,
        FeeControlModule,
        ListPickerControlModule,
        MembershipControlModule,
        PassAlertFailControlModule,
        RegLookupControlModule,
        RichTextControlModule,
        SelectContactControlModule.forRoot(),
        SplatControlModule,
        TextareaControlModule,
        TextControlModule,
        ToggleControlModule,
        UserListPickerControlModule
    ],
    exports: [
        AclCategoryModule,
        CheckBoxListControlModule,
        ComplexControlModule,
        ContactControlModule,
        CostsControlModule,
        DateTimeControlModule,
        FeeControlModule,
        ListPickerControlModule,
        MembershipControlModule,
        PassAlertFailControlModule,
        RegLookupControlModule,
        RichTextControlModule,
        SelectContactControlModule,
        SelectControlConfigModule,
        SplatControlModule,
        TextareaControlModule,
        TextControlModule,
        ToggleControlModule,
        UserListPickerControlModule
    ]
})
export class ControlsModule {

}



// WEBPACK FOOTER //
// ./src/vas/controls/controls.module.ts